<template>
  <div class="modal">
    <div class="login_wrap">
      <img src="../assets/images/login/loginGif.png" class="login_wrap_left"/>
      <div class="login_wrap_right">
        <!-- 关闭 -->
        <div class="close">
          <svg aria-hidden="true" class="icon" @click="closeLog">
            <use xlink:href="#icon-close"></use>
          </svg>
        </div>
        <!-- 切换 -->
        <el-tabs class="login_tab" v-model="activeType" @tab-click="changeTab">
          <el-tab-pane label="用户登录" name="1"> </el-tab-pane>
          <el-tab-pane label="手机注册" name="2"> </el-tab-pane>
        </el-tabs>
        <!-- 提示 -->
        <p class="login_tip" v-show="errTip" :title="errTip">
          <svg aria-hidden="true" class="icon">
            <use xlink:href="#icon-tip"></use>
          </svg>
          {{ errTip }}
        </p>
        <el-form :model="logForm" ref="logForm" class="login_form" :rules="formRule">
          <el-form-item prop="account">
            <el-input name="username" v-model.trim="logForm.account" autocomplete="off" :placeholder="
                activeType == 1?'用户名/邮箱/手机号（可用已注册的知网个人账号登录）':(activeType == 2?'手机号':
                '用户名')">
              <template slot="prefix">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-user"></use>
                </svg>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="messageCode" class="valid_code_item" v-if="activeType == 2">
            <el-input v-model.trim="logForm.messageCode" placeholder="验证码" autocomplete="off">
              <template slot="prefix">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-yzm"></use>
                </svg>
              </template>
              <template slot="append">
                <font @click="getMessageCode">{{ verifyText }}</font>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" :class="{ 'last_item': !showVerifyCode}">
            <el-input type="password" name="password" placeholder="密码" v-model.trim="logForm.password" autocomplete="off">
              <template slot="prefix">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-password"></use>
                </svg>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="verifyCode" class="valid_item" :class="{ 'last_item': showVerifyCode }"
            v-if="showVerifyCode&& activeType == 1">
            <el-input placeholder="验证码" class="yzm" name="verifyCode" v-model="logForm.verifyCode">
              <template slot="prefix">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-yzm"></use>
                </svg>
              </template>
            </el-input>
            <span class="randomCode" @click="getImgVerifyCode">{{code}}</span>
          </el-form-item>
          <el-form-item prop="agree" class="agree-item">
            <!-- <div v-if="activeType == 1">
              <el-checkbox v-model="logForm.agree"></el-checkbox>
              我已阅读并接受<font @click="readProtocol(2)">《隐私政策》</font>的内容
            </div> -->
            <!-- <div>
              <el-checkbox v-model="logForm.agree"></el-checkbox>
              我已阅读并同意华知大模型相关<font @click="readProtocol(1)">《使用协议》</font>和<font @click="readProtocol(2)">《隐私政策》</font>
              
            </div> -->
          </el-form-item>
        </el-form>
        <!-- 同意协议 -->
        <div class="login_agree">
          <span class="right" v-if="activeType == 1" @click="findPassword">找回密码&nbsp;&nbsp;>></span>
          <span class="right" v-if="activeType == 2" @click="changeTab({ name: '1' })">返回登录&nbsp;&nbsp;>></span>
        </div>
        <el-button type="primary" class="login_btn" :loading="btnLoading" @click="logOrRegister">{{ activeType == 2 ?
          "注册" : "登录" }}</el-button>
         <!-- 第三方登录 -->
        <!-- <div class="login_three_icon" v-if="activeType == 1">
          <span @click="thirdLogin('qq')">
            <svg aria-hidden="true" class="icon">
              <use xlink:href="#icon-qq"></use>
            </svg>
          </span>
          <span @click="thirdLogin('weixin')">
            <svg aria-hidden="true" class="icon">
              <use xlink:href="#icon-wechat"></use>
            </svg>
          </span>
          <span @click="thirdLogin('sina')">
            <svg aria-hidden="true" class="icon">
              <use xlink:href="#icon-weibo"></use>
            </svg>
          </span>
          <span @click="thirdLogin('163')">
            <svg aria-hidden="true" class="icon">
              <use xlink:href="#icon-wangyi"></use>
            </svg>
          </span>
        </div> -->
        <p class="login_bot_tip">{{activeType == 2?'上述个人信息仅用于注册账号':'上述个人信息仅用于登录验证'}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import registerMixins from "@/mixins/registerMixins.js";
import '@/assets/scss/login.scss'
export default {
  data(){
    return {
      activeType: "1",
      code: "",
      external: "",
      logForm: {
        account: "",
        password: "",
        messageCode: "",
        verifyCode: "",
        agree: false
      },
      showVerifyCode: false,
      sending: false,
      verifyText: "点击发送验证码",
    };
  },
  mixins: [registerMixins],
  methods: {
    //查看协议
    readProtocol(index){
      this.$parent.readProtocol(index);
    },
    //关闭登录弹框
    closeLog(){
      this.changeTab({ name: "1" });
      this.$parent.showLogin = false;
    },
    //找回密码
    findPassword(){
      window.open("https://my.cnki.net/mycnki/forgetPassword.html", "_blank");
    },
    //切换登录注册
    changeTab(tab){
      this.activeType = tab.name;
      this.errTip = "";
      this.$refs["logForm"].resetFields();
      this.$nextTick(this.$refs["logForm"].clearValidate)
    },
    //调用登录或注册接口
    logOrRegister(){
      if (this.activeType == 1) this.login();
      else this.register();
    },
    // 第三方登录
    thirdLogin(str){
      let w = window.innerWidth >> 1,
        l = (window.innerWidth - w) >> 1,
        t = 100,
        h = (window.innerHeight * 0.6) | 0,
        redirectUrl =
          window.location.origin +
          "/foundation/#/transfer?type=" +
          str +
          "&Redirect=" +
          window.location.origin;
      this.external = window.open(
        "",
        "_blank",
        "width=" + w + ",height=" + h + ",top=" + t + ",left=" + l
      );
      this.external.location =
        window.location.protocol +
        "//my.cnki.net/ThirdLogin/ThirdLogin.aspx?to=" +
        str +
        "&RedirectUrl=" +
        encodeURIComponent(redirectUrl);
    },
  },
  mounted(){
    document.body.style.overflow = "hidden";
  },
  destroyed(){
    document.body.style.overflow = "auto";
    this.errTip = "";
  },
};
</script>

